import { FEATURE_KEY, State } from './open-trip-planner.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const openTripPlannerState = createFeatureSelector<State>(FEATURE_KEY);

export const routes = createSelector(openTripPlannerState, (state: State) => state.routes);
export const routesGroups = createSelector(openTripPlannerState, (state: State) => state.routesGroups);
export const stops = createSelector(openTripPlannerState, (state: State) => state.stops);
export const allFormattedStops = createSelector(stops, (stopsData) =>
    stopsData.map((s) => ({
        ...s,
        latlng: { lat: s.lat, lng: s.lon }
    }))
);

export const location = createSelector(openTripPlannerState, (state: State) => state.location);
export const search = createSelector(openTripPlannerState, (state: State) => state.search);
export const exploreMapStops = createSelector(openTripPlannerState, (state: State) => state.exploreMapStops);
export const exploreMapRoute = createSelector(openTripPlannerState, (state: State) => state.exploreMapRoute);
export const journeyMapPlan = createSelector(openTripPlannerState, (state: State) => state.journeyMapPlan);
export const nearbyStops = createSelector(openTripPlannerState, (state: State) => state.nearbyStops);
export const nearbyStopsLoading = createSelector(openTripPlannerState, (state: State) => state.nearbyStopsLoading);

export const plan = createSelector(openTripPlannerState, (state: State) => state.plan);
export const itineraries = createSelector(openTripPlannerState, (state: State) => state.plan.itineraries);
export const selectedItineraryForDetails = createSelector(
    openTripPlannerState,
    (state: State) => state.selectedItineraryForDetails
);
export const searchRecentlyJourneys = createSelector(
    openTripPlannerState,
    (state: State) => state.searchRecentlyJourneys
);
export const trips = createSelector(openTripPlannerState, (state: State) => state.trips);
export const alerts = createSelector(openTripPlannerState, (state: State) => state.alerts);
